import get from 'lodash/get';

/**
 * Get error message of input
 * implement with react-hook-form
 * @param {string} name name of iput
 * @param {object} field error state
 * @returns errorMsg
 */
export const getErrorMessage = (name, field) =>
  get(field, `${name}.message`, '');

/**
 * Convert preset values like '1024_70' to API-ready image config objects.
 * Falls back to [{ size:1024, quality:70 }] if input is empty/invalid.
 * @param {string[]} presets
 * @returns {{size:number, quality:number}[]}
 */
export const buildImageConfigFromPresets = (presets) => {
  const list = Array.isArray(presets) ? presets : [];
  if (!list.length) {
    return [{ size: 1024, quality: 70 }];
  }
  const parsePreset = (input) => {
    if (!input) return null;
    // Support objects from react-select
    const raw = typeof input === 'object' ? input.value || input.label : input;
    if (!raw) return null;
    // Case 1: "1024_70"
    if (typeof raw === 'string' && raw.includes('_')) {
      const [sizeStr, qualityStr] = raw.split('_');
      const size = Number(sizeStr);
      const quality = Number(qualityStr);
      if (!size || !quality) return null;
      return { size, quality };
    }
    // Case 2: "Size 1024 - Quality 70%" or similar human-readable labels
    const match = String(raw).match(/(\d+)[^\d]+(\d+)%?/);
    if (match) {
      const size = Number(match[1]);
      const quality = Number(match[2]);
      if (!size || !quality) return null;
      return { size, quality };
    }
    return null;
  };
  const config = list.map(parsePreset).filter(Boolean);
  return config.length ? config : [{ size: 1024, quality: 70 }];
};